import { render, staticRenderFns } from "./studioDashboardDaycareStatistic.vue?vue&type=template&id=d052fbb8&scoped=true"
import script from "./studioDashboardDaycareStatistic.vue?vue&type=script&lang=js"
export * from "./studioDashboardDaycareStatistic.vue?vue&type=script&lang=js"
import style0 from "./studioDashboardDaycareStatistic.vue?vue&type=style&index=0&id=d052fbb8&prod&lang=scss&scoped=true"
import style1 from "./studioDashboardDaycareStatistic.vue?vue&type=style&index=1&id=d052fbb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d052fbb8",
  null
  
)

export default component.exports